export var defaultUploadParams = {
    collection: '',
};
//# sourceMappingURL=uploadParams.js.map